import { Injectable } from "@angular/core";
import { HttpHandlerService } from "./http-handler.service";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
@Injectable({
  providedIn: "root",
})
export class ExecutiveViewService {
  constructor(private readonly _httpHandlerService: HttpHandlerService) {}

  public getExposureStatsData(
    startDate: any,
    endDate: any,
    selectedTenant: any
  ) {
    return this._httpHandlerService.get(
      `rnv/api/exposures/count?startDate=${startDate}&endDate=${endDate}` +
        (selectedTenant ? `&tenantId=${selectedTenant}` : "")
    );
  }

  public getIdentityExposureData(
    startDate: any,
    endDate: any,
    selectedTenant: any
  ) {
    return this._httpHandlerService.get(
      `rnv/api/exposures/identity?startDate=${startDate}&endDate=${endDate}` +
        (selectedTenant ? `&tenantId=${selectedTenant}` : "")
    );
  }

  public getInformationExposureData(
    startDate: any,
    endDate: any,
    selectedTenant: any
  ) {
    return this._httpHandlerService.get(
      `rnv/api/exposures/information?startDate=${startDate}&endDate=${endDate}` +
        (selectedTenant ? `&tenantId=${selectedTenant}` : "")
    );
  }

  public getLeakedSessionData(
    startDate: any,
    endDate: any,
    selectedTenant: any
  ) {
    return this._httpHandlerService.get(
      `rnv/api/exposures/leaked-session?startDate=${startDate}&endDate=${endDate}` +
        (selectedTenant ? `&tenantId=${selectedTenant}` : "")
    );
  }

  public getVulnerabilityExposureData(
    startDate: any,
    endDate: any,
    selectedTenant: any
  ) {
    return this._httpHandlerService.get(
      `rnv/api/exposures/vulnerabilities?startDate=${startDate}&endDate=${endDate}` +
        (selectedTenant ? `&tenantId=${selectedTenant}` : "")
    );
  }

  public getMisconfigurationData(
    startDate: any,
    endDate: any,
    selectedTenant: any
  ) {
    return this._httpHandlerService.get(
      `rnv/api/exposures/misconfigurations?startDate=${startDate}&endDate=${endDate}` +
        (selectedTenant ? `&tenantId=${selectedTenant}` : "")
    );
  }
  public getTopRisksData(startDate: any, endDate: any, selectedTenant: any) {
    return this._httpHandlerService.get(
      `rnv/api/client/risk?startDate=${startDate}&endDate=${endDate}` +
        (selectedTenant ? `&tenantId=${selectedTenant}` : "")
    );
  }
  public getComplianceRegulationData(selectedTenant: any) {
    return this._httpHandlerService.get(
      `rnv/api/risk/chart/compliance-regulation` +
        (selectedTenant ? `?tenantId=${selectedTenant}` : "")
    );
  }
  public getComplianceStandardData(selectedTenant: any) {
    return this._httpHandlerService.get(
      `rnv/api/risk/chart/compliance-standards` +
        (selectedTenant ? `?tenantId=${selectedTenant}` : "")
    );
  }

  public getIndustryThreatReportData(selectedTenant: any) {
    return this._httpHandlerService.get(
      `rnv/api/threat/industry-threat-report` +
        (selectedTenant ? `?tenantId=${selectedTenant}` : "")
    );
  }

  public getTopAPTgroupDrillDownData(selectedTenant: any) {
    return this._httpHandlerService.get(
      `rnv/api/threat/top-apt-group` +
        (selectedTenant ? `?tenantId=${selectedTenant}` : "")
    );
  }

  public getPhishingDrillDownData(selectedTenant: any) {
    return this._httpHandlerService.get(
      `rnv/api/threat/phishing-company` +
        (selectedTenant ? `?tenantId=${selectedTenant}` : "")
    );
  }

  public getMalwareDrillDownData(selectedTenant: any) {
    return this._httpHandlerService.get(
      `rnv/api/threat/malware-company` +
        (selectedTenant ? `?tenantId=${selectedTenant}` : "")
    );
  }

  public getRansomewareThreatsDrillDownData(selectedTenant: any) {
    return this._httpHandlerService.get(
      `rnv/api/threat/ransomware-threat` +
        (selectedTenant ? `?tenantId=${selectedTenant}` : "")
    );
  }

  public getTopAttackingCountriesDrillDownData(selectedTenant: any) {
    return this._httpHandlerService.get(
      `rnv/api/threat/top-attacking-country` +
        (selectedTenant ? `?tenantId=${selectedTenant}` : "")
    );
  }

  public getNationCyberStrategies(selectedTenant: any) {
    return this._httpHandlerService.get(
      `rnv/api/client/nation-cyber` +
        (selectedTenant ? `?tenantId=${selectedTenant}` : "")
    );
  }

  public getRiskRatingData(isMonthly: boolean, selectedTenant: any) {
    return this._httpHandlerService.get(
      `rnv/api/client/risk-rating?isMonthly=${isMonthly}` +
        (selectedTenant ? `&tenantId=${selectedTenant}` : "")
    );
  }

  public getUserData(id: any) {
    return this._httpHandlerService.get(
      `onboarding/query/user-profile?userUUId=${id}`
    );
  }

  public getGraphPermissionData(id: any) {
    return this._httpHandlerService.get(
      `onboarding/configure/graph-access?userId=${id}`
    );
  }

  public getVipUsersData(
    pageNumber: any = 0,
    pageSize: any = 3,
    countries: any,
    selectedTenant: any
  ) {
    const queryParams = new URLSearchParams();

    // Only add countryList if countries array is not empty
    if (countries && countries.length > 0) {
      countries.forEach((country: any) => {
        queryParams.append("countryList", country);
      });
    }

    // Add other params
    if (pageSize !== undefined)
      queryParams.append("pageSize", pageSize.toString());
    if (pageNumber !== undefined)
      queryParams.append("pageNumber", pageNumber.toString());
    if (selectedTenant) queryParams.append("tenantId", selectedTenant);
    return this._httpHandlerService.get(
      `rnv/api/client/vip-user?${queryParams.toString()}`
    );
  }

  exportToExcel(dataList: any, columns: any, title: any): void {
    const rows = dataList;
    const columnKeys = columns.map((col: any) => col.key);

    const excelData = rows.map((row: any, index: any) => {
      const rowData: any = {};
      columnKeys.forEach((key: any) => {
        if (key === "srNo") {
          rowData["Sr No"] = index + 1;
        } else {
          let value = this.getNestedValue(row, key);
          rowData[columns.find((col: any) => col.key === key)?.label ?? key] =
            columns.find((col: any) => col.key === key)?.type === "date"
              ? new Date(value).toLocaleDateString()
              : value;
        }
      });
      return rowData;
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
    const workbook: XLSX.WorkBook = {
      Sheets: { Data: worksheet },
      SheetNames: ["Data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data: Blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    FileSaver.saveAs(
      data,
      `${title ?? "export"}-${new Date().toISOString()}.xlsx`
    );
  }

  getNestedValue(obj: any, path: string): any {
    return path.split(".").reduce((acc, key) => acc?.[key], obj);
  }
}
